import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import ProtectedRoute, { SuperRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Inventory from "@/pages/Inventory";
import Quotations from "@/pages/Quotations";
import Tenders from "@/pages/Tenders";
import QuotationBuilder from "@/pages/QuotationBuilder";
import POS from "@/pages/POS";
import Customers from "@/pages/Customers";
import Suppliers from "@/pages/Suppliers";
import Procurement from "@/pages/Procurement";
import Documents from "@/pages/Documents";
import SOPs from "@/pages/SOPs";
import Onboarding from "@/pages/Onboarding";
import Users from "@/pages/Users";
import AuditLogs from "@/pages/AuditLogs";
import Returns from "@/pages/Returns";
import Receivables from "@/pages/Receivables";
import Cylinders from "@/pages/Cylinders";
import Pricing from "@/pages/Pricing";
import StockTakes from "@/pages/StockTakes";
import Shifts from "@/pages/Shifts";
import Margins from "@/pages/Margins";
import PublicQuote from "@/pages/PublicQuote";
import DeliveryNotes from "@/pages/DeliveryNotes";
import DocumentFlow from "@/pages/DocumentFlow";
import DocumentFolders from "@/pages/DocumentFolders";
import ResetPage from "@/pages/ResetPage";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <ConfirmProvider>
          <Toaster position="top-right" richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/quote/:token" element={<PublicQuote />} />
              <Route path="/pos" element={<ProtectedRoute><POS /></ProtectedRoute>} />
              <Route
                path="/"
                element={<ProtectedRoute><Layout /></ProtectedRoute>}
              >
                <Route index element={<Dashboard />} />
                <Route path="products" element={<Products />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="quotations" element={<Quotations />} />
                <Route path="quotations/new" element={<QuotationBuilder />} />
                <Route path="quotations/:id" element={<QuotationBuilder />} />
                <Route path="invoices/:id/edit" element={<QuotationBuilder />} />
                <Route path="tenders" element={<Tenders />} />
                <Route path="customers" element={<Customers />} />
                <Route path="suppliers" element={<Suppliers />} />
                <Route path="procurement" element={<Procurement />} />
                <Route path="documents" element={<Documents />} />
                <Route path="sops" element={<SOPs />} />
                <Route path="onboarding" element={<Onboarding />} />
                <Route path="returns" element={<Returns />} />
                <Route path="receivables" element={<Receivables />} />
                <Route path="cylinders" element={<Cylinders />} />
                <Route path="pricing" element={<Pricing />} />
                <Route path="stock-takes" element={<StockTakes />} />
                <Route path="shifts" element={<Shifts />} />
                <Route path="margins" element={<Margins />} />
                <Route path="delivery-notes" element={<DeliveryNotes />} />
                <Route path="document-flow" element={<DocumentFlow />} />
                <Route path="folders" element={<DocumentFolders />} />
                <Route path="reset" element={<SuperRoute><ResetPage /></SuperRoute>} />
                <Route path="users" element={<SuperRoute><Users /></SuperRoute>} />
                <Route path="audit" element={<SuperRoute><AuditLogs /></SuperRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ConfirmProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
